(function () {
  function isHidden(el) {
    if (!el) return true;
    return window.getComputedStyle(el).display === 'none' || window.getComputedStyle(el).visibility === 'hidden';
  }

  function fixHiddenOrDisabledCheckedOptions() {
    document.querySelectorAll('variant-selects fieldset, variant-radios fieldset').forEach(function (fieldset) {
      var checkedInput = fieldset.querySelector('input[type="radio"]:checked');

      if (!checkedInput) return;

      var checkedLabel = fieldset.querySelector('label[for="' + checkedInput.id + '"]');

      var checkedIsBad =
        checkedInput.disabled ||
        checkedInput.classList.contains('disabled') ||
        isHidden(checkedInput) ||
        isHidden(checkedLabel);

      if (!checkedIsBad) return;

      var availableInputs = Array.from(fieldset.querySelectorAll('input[type="radio"]')).filter(function (input) {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');

        return (
          !input.disabled &&
          !input.classList.contains('disabled') &&
          !isHidden(input) &&
          !isHidden(label)
        );
      });

      if (!availableInputs.length) return;

      availableInputs[0].click();
    });
  }

  function scheduleFix() {
    setTimeout(fixHiddenOrDisabledCheckedOptions, 50);
    setTimeout(fixHiddenOrDisabledCheckedOptions, 200);
    setTimeout(fixHiddenOrDisabledCheckedOptions, 500);
  }

  document.addEventListener('DOMContentLoaded', scheduleFix);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('variant-selects input[type="radio"]') ||
      event.target.matches('variant-radios input[type="radio"]')
    ) {
      scheduleFix();
    }
  });
})();

/* Felső almenük megnyitása egérrel */
(function () {
  const desktopHover = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  const initialized = new WeakSet();

  function initHoverMenus() {
    document.querySelectorAll('.header__inline-menu').forEach(function (nav) {
      const items = nav.querySelectorAll('.list-menu--inline > li');

      items.forEach(function (item) {
        if (initialized.has(item)) return;

        const menu = item.querySelector('header-menu');
        const details = menu && menu.querySelector('details');
        const summary = details && details.querySelector('summary');

        let closeTimer;

        function closeMenu() {
          clearTimeout(closeTimer);

          if (!details) return;

          if (typeof menu.close === 'function') {
            menu.close();
          } else {
            details.open = false;
          }

          summary.setAttribute('aria-expanded', 'false');
        }

        item.addEventListener('mouseenter', function () {
          if (!desktopHover.matches) return;

          clearTimeout(closeTimer);

          /* Másik felső menü bezárása */
          items.forEach(function (otherItem) {
            if (otherItem === item) return;

            const otherMenu = otherItem.querySelector('header-menu');
            const otherDetails = otherMenu && otherMenu.querySelector('details');

            if (!otherDetails || !otherDetails.open) return;

            if (typeof otherMenu.close === 'function') {
              otherMenu.close();
            } else {
              otherDetails.open = false;
              otherDetails.querySelector('summary')
                .setAttribute('aria-expanded', 'false');
            }
          });

          if (details) {
            details.open = true;
            summary.setAttribute('aria-expanded', 'true');
          }
        });

        item.addEventListener('mouseleave', function () {
          if (!desktopHover.matches || !details) return;

          clearTimeout(closeTimer);
          closeTimer = setTimeout(closeMenu, 200);
        });

        initialized.add(item);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }

  document.addEventListener('shopify:section:load', initHoverMenus);
})();

(() => {
  function updateShippingLinks() {
    document
      .querySelectorAll('cart-drawer a[href], .tax-note a[href]')
      .forEach((link) => {
        const url = new URL(link.getAttribute('href'), location.href);

        if (url.origin !== location.origin) return;

        const match = url.pathname.match(
          /^(.*?)\/(?:policies\/shipping-policy|pages\/szallitas)\/?$/
        );

        if (!match) return;

        link.href =
          match[1] + '/pages/szallitas' + url.search + url.hash;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      });
  }

  function init() {
    updateShippingLinks();

    new MutationObserver(updateShippingLinks).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();